/** The bucket size of `reach`, in px: the heatmap route floors to it. */
export const REACH_BUCKET = 100

/** Visits by the furthest pixel they saw, in 100px buckets, ascending. */
export type Reach = { y: number; n: number }[]

/** The y (frame px) by which only `share` of measured visits are still
 *  reading: the line a "half of visitors stop here" marker sits on. */
export function reachLine(reach: Reach, share: number): number | undefined {
  const total = reach.reduce((sum, bucket) => sum + bucket.n, 0)
  if (total === 0) return undefined
  /* visits that reached at least bucket.y: everything from it onwards */
  let remaining = total
  for (const bucket of reach) {
    if (remaining / total < share) return bucket.y
    remaining -= bucket.n
  }
  /* nobody read past the last bucket: the line sits at its far edge, and the
     overlay drops it if that lies beyond the page */
  const last = reach.at(-1)
  return last ? last.y + REACH_BUCKET : undefined
}
